import { action } from 'satcheljs';

export const onReportLinkClicked = action('onReportLinkClicked');
